import React from 'react';
import PropTypes from 'prop-types';

import '../css/accordion.less';

const AccordionHeader = ({ MetricsWrapper, toggleMenu, title }) =>
    MetricsWrapper ? (
        <MetricsWrapper
            content={
                <h3 className="accordion-header" onClick={toggleMenu}>
                    {title}
                    <span className="arrow"></span>
                </h3>
            }
        />
    ) : (
        <h3 className="accordion-header" onClick={toggleMenu}>
            {title}
            <span className="arrow"></span>
        </h3>
    );

class Accordion extends React.Component {
    static propTypes = {
        lazyLoad: PropTypes.bool,
        title: PropTypes.string.isRequired,
        children: PropTypes.element.isRequired,
        children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        defaultState: PropTypes.bool,
        className: PropTypes.string,
        //MetricsWrapper is an optional prop. should be defined in this scope to prevent event bubling
        MetricsWrapper: PropTypes.func,
        expanded: PropTypes.bool,
        onExpand: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.state = {
            expanded: this.props.defaultState || false,
            loaded: this.props.lazyLoad ? false : true,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tabIndex !== this.props.tabIndex && this.props.tabIndex) {
            if (this.props.tabIndex === this.props.accordionKey) {
                this.setState({ expanded: true, loaded: true });
                this.props.handleTabChange(null);
            }
        }
        if (prevProps.expanded !== this.props.expanded) {
            this.setState({ expanded: this.props.expanded });
        }
    }

    toggleMenu(accordionKey) {
        const { onExpand } = this.props;
        if (onExpand) onExpand(accordionKey);
        this.setState({
            expanded: !this.state.expanded,
            loaded: true,
        });
    }

    render() {
        const { MetricsWrapper, title, accordionKey, prefetch } = this.props;
        return (
            <div
                className={`accordion-group${this.state.expanded ? ' expanded' : ''}${
                    this.props.className ? ' ' + this.props.className : ''
                } accordion-${accordionKey}`}
            >
                <AccordionHeader
                    MetricsWrapper={MetricsWrapper}
                    toggleMenu={() => this.toggleMenu(accordionKey)}
                    title={title}
                />
                <div className="accordion-content">
                    {React.Children.map(this.props.children, child => {
                       return this.state.loaded || prefetch ? child : null
                    })}
                </div>
            </div>
        );
    }
}

export default Accordion;
